import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Checkbox, FormControlLabel, Grid, Radio, TextField, Typography, IconButton } from "@mui/material";
import { useCallback } from "react";
import React, { useEffect, useState } from "react";
import { MdExpandMore } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import courseActions from "../../redux/course/actions";
import { cssProperties } from "../../utils/commonCssProperties";
import { Modal } from "@mui/material";
import { IoMdClose } from "react-icons/io";
import { debounce } from 'lodash';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 600,
    bgcolor: 'background.paper',
    border: '1px solid #000',
    boxShadow: 24,
    p: 4,
};


export default function CourseTabAndFields() {
    const [openDocModal, setOpenDocModal] = useState(false);
    const [modalSpecificData, setModalSpecificData] = useState();
    const [docChecked, setDocChecked] = useState(false);
    const [customText, setCustomText] = useState("");
    const [initialized, setInitialized] = useState(false);




    const dispatch = useDispatch();

    const { courseTabMaster, courseFieldMaster } = useSelector(state => state.courseReducer);


    //  const setTabFieldData = ()=>{
    //     if(courseTabMaster.length > 0 && courseFieldMaster.length > 0){
    //         let array = [...courseTabMaster];
    //         // array[index].isActive = value;

    //         for(let k = 0; k < array?.length; k++){
    //             array[k].isActive = array[k].isactive === '1';
    //             let array2 = [...courseFieldMaster];
    //             for (let i = 0; i < array2?.length; i++) {
    //                 if (array2[i]?.coursetabid === array[k].coursetabid) {
    //                     array2[i].isSelected = array[k].coursetabid;
    //                     array2[i].fieldlabel = array2[k].fieldname;
    //                     array2[i].fieldlabelerror = false;
    //                     array2[i].ismandatory = false;
    //                     array2[i].isreadonly = false;
    //                 }
    //             };
    //             dispatch({ type: courseActions.SET_COURSEFIELD_MASTER, payload: array2 });
    //             // array[k].selectAll = false;
    //             // array[k].mandatorySelectAll = false;
    //         }

    //         dispatch({ type: courseActions.SET_COURSETAB_MASTER, payload: array });
    //     }
    //  }
    // useEffect(()=>{
    //     setTimeout(()=>{
    //         setTabFieldData()

    //     },3000)
    // },[])
    const handleCourseTabChange = (index, value, tabid) => {
        let array = [...courseTabMaster];
        array[index].isActive = value;
        if (value === false) {
            let array2 = [...courseFieldMaster];
            for (let i = 0; i < array2?.length; i++) {
                if (array2[i]?.coursetabid === tabid) {
                    array2[i].isSelected = false;
                    array2[i].fieldlabel = array2[i].fieldname;
                    array2[i].fieldlabelerror = false;
                    array2[i].ismandatory = false;
                    array2[i].isreadonly = false;
                }
            };
            dispatch({ type: courseActions.SET_COURSEFIELD_MASTER, payload: array2 });
            array[index].selectAll = false;
            array[index].mandatorySelectAll = false;
        }
        dispatch({ type: courseActions.SET_COURSETAB_MASTER, payload: array });
    };

    const handleSelectAll = (e, tabid) => {
        let isChecked = e.target.checked;
        let array = [...courseFieldMaster];
        for (let i = 0; i < array?.length; i++) {
            if (array[i]?.coursetabid === tabid) {
                array[i].isSelected = isChecked;
                if (!isChecked) {
                    array[i].fieldlabel = array[i].fieldname;
                    array[i].fieldlabelerror = false;
                    array[i].ismandatory = false;
                    array[i].isreadonly = false;
                }
            }
        };
        dispatch({ type: courseActions.SET_COURSEFIELD_MASTER, payload: array });
        let tabarray = [...courseTabMaster];
        let tabind = tabarray?.findIndex(val => val?.coursetabid === tabid);
        if (tabind !== -1) {
            tabarray[tabind].selectAll = isChecked;
            if (!isChecked) {
                tabarray[tabind].mandatorySelectAll = isChecked;
            }
        }
        dispatch({ type: courseActions.SET_COURSETAB_MASTER, payload: tabarray });
    };

    const handleMandatorySelectAll = (e, tabid) => {
        let isChecked = e.target.checked;
        let array = [...courseFieldMaster];
        for (let i = 0; i < array?.length; i++) {
            if (array[i]?.coursetabid === tabid) {
                array[i].ismandatory = isChecked;
                // if (!isChecked) {
                //     array[i].fieldlabel = array[i].fieldname;
                //     array[i].fieldlabelerror = false;
                //     array[i].ismandatory = false;
                //     array[i].isreadonly = false;
                // }
            }
        };
        dispatch({ type: courseActions.SET_COURSEFIELD_MASTER, payload: array });
        let tabarray = [...courseTabMaster];
        let tabind = tabarray?.findIndex(val => val?.coursetabid === tabid);
        if (tabind !== -1) {
            tabarray[tabind].mandatorySelectAll = isChecked;
        }
        dispatch({ type: courseActions.SET_COURSETAB_MASTER, payload: tabarray });
    };

    const handleSelectField = (e, fieldid) => {
        let isChecked = e.target.checked;
        let array = [...courseFieldMaster];
        let fieldindex = array.findIndex(val => val?.coursefieldid === fieldid);
        array[fieldindex].isSelected = isChecked;
        if (isChecked) {
            let childarray = array.filter((c) => {
                if (parseInt(c.parentfieldid) === parseInt(fieldid)) {
                    return c;
                }
            })?.map(ca => { return ca.coursefieldid });
            if (childarray?.length > 0) {
                for (let i = 0; i < childarray?.length; i++) {
                    let childindex = array.findIndex(cf => cf.coursefieldid === childarray[i]);
                    array[childindex].isSelected = isChecked;
                }
            };
        } else {
            array[fieldindex].fieldlabel = array[fieldindex].fieldname;
            array[fieldindex].fieldlabelerror = false;
            array[fieldindex].ismandatory = false;
            array[fieldindex].isreadonly = false;
        }
        dispatch({ type: courseActions.SET_COURSEFIELD_MASTER, payload: array });
    };

    const handleFieldLabelChange = (e, fieldid) => {
        let array = [...courseFieldMaster];
        let fieldindex = array.findIndex(val => val?.coursefieldid === fieldid);
        array[fieldindex].fieldlabel = e.target.value;
        array[fieldindex].fieldlabelerror = false;
        if (e.target.value?.length === 0) {
            array[fieldindex].fieldlabelerror = true;
        };
        dispatch({ type: courseActions.SET_COURSEFIELD_MASTER, payload: array });
    };

    const handleMandatoryChange = (e, fieldid) => {
        let isChecked = e.target.checked;
        let array = [...courseFieldMaster];
        let fieldindex = array.findIndex(val => val?.coursefieldid === fieldid);
        array[fieldindex].ismandatory = isChecked;
        dispatch({ type: courseActions.SET_COURSEFIELD_MASTER, payload: array });
    };

    const handleReadonlyChange = (e, fieldid) => {
        let isChecked = e.target.checked;
        let array = [...courseFieldMaster];
        let fieldindex = array.findIndex(val => val?.coursefieldid === fieldid);
        array[fieldindex].isreadonly = isChecked;
        dispatch({ type: courseActions.SET_COURSEFIELD_MASTER, payload: array });
    };


    const documentUrlArr = useSelector(
        (state) => state?.courseReducer?.courseFieldDocument?.data?.result
    );



    const matchingDocument = documentUrlArr?.find((doc) =>
        modalSpecificData?.fieldname
            ?.toLowerCase()
            .includes(doc?.description?.toLowerCase())
    );

    const [customLinkField, setCustomLink] = useState("");

    useEffect(() => {
        if (documentUrlArr) {
            const matchingDocument = documentUrlArr?.find((doc) =>
                modalSpecificData?.fieldname?.toLowerCase().includes(doc?.description?.toLowerCase())
            );

            // const matchingDocument = documentUrlArr?.find((doc) =>
            //     doc?.description?.toLowerCase().includes(modalSpecificData?.fieldname?.toLowerCase())
            //   );
            setCustomLink(matchingDocument?.service_url);
        }

    }, [documentUrlArr, modalSpecificData]);


    // const handleCustomLinkChange = (e, data) => {
    //     setCustomLink(e.target.value);
    // };

    const handleCustomLinkChange = useCallback((e) => {
        setCustomLink(e.target.value);
    }, []);




    const handleOpenDocumentModal = (data) => {
        setOpenDocModal(data?.coursefieldid);
        setModalSpecificData(data);
        dispatch({
            type: courseActions.GET_FIELDSDOCUMENT_MASTER
        });
    };

    const handleCheckBoxChange = (event) => {
        setDocChecked(event.target.checked);
    };

    const handleCustomTextChange = (e, matchingDocument) => {
        setCustomText(e.target.value);
    };




    useEffect(() => {
        if (matchingDocument?.description && modalSpecificData?.fieldname) {
            const desc = matchingDocument?.description?.toLowerCase();
            const fieldname = modalSpecificData?.fieldname?.toLowerCase();
            if (fieldname?.includes(desc)) {
                setCustomText(modalSpecificData?.additionalFields?.displayText);
            }
        }
    }, [openDocModal]);



    // const handleSubmitDocumentUrlFunc = (data) => {
    //     console.log(data,"data consoeldnbid")
    //     setCustomText("")
    //     const fieldArray = [
    //         "Category",
    //         "Are you Domiciled in the State of Maharashtra ?",
    //         "Do you want to Apply for EWS (Economically Weaker Section) Seats ?",
    //         "Are you Orphan?"
    //     ];

    //     const updatedArray = courseFieldMaster?.map((e) => {
    //         const isMatch = fieldArray?.some((field) => {
    //             return e.fieldname?.trim().toLowerCase().includes(field.trim().toLowerCase())
    //         },
    //         );

    //         return isMatch
    //             ? {
    //                 ...e,
    //                 additionalFields: {
    //                     displayText: customText || null,
    //                     link: customLinkField || null,
    //                 },
    //             }
    //             : e;
    //     });
    //     // dispatch({
    //     //     type: courseActions.SET_COURSEFIELD_MASTER,
    //     //     payload: updatedArray,
    //     // });
    //     // setOpenDocModal(false)

    // };

    const handleSubmitDocumentUrlFunc = (targetFieldName) => {
        // setCustomText("");
        const updatedArray = courseFieldMaster?.map((e) => {
            const isMatch = e?.fieldname?.trim().toLowerCase() === targetFieldName?.trim()?.toLowerCase();
            return isMatch
                ? {
                    ...e,
                    additionalFields: {
                        displayText: customText || null,
                        link: customLinkField || null,
                    },
                }
                : e;
        });

        dispatch({
            type: courseActions.SET_COURSEFIELD_MASTER,
            payload: updatedArray,
        });
        setOpenDocModal(false);
    };


    const handleCloseModal = () => {
        if (!docChecked && modalSpecificData?.fieldname) {
            const updatedArray = courseFieldMaster.map(e => {
                if (
                    e.fieldname?.trim().toLowerCase() ===
                    modalSpecificData.fieldname.trim().toLowerCase()
                ) {
                    return {
                        ...e,
                        additionalFields: {}
                    };
                }
                return e;
            });

            dispatch({
                type: courseActions.SET_COURSEFIELD_MASTER,
                payload: updatedArray
            });
        }
        setOpenDocModal(false);
    };







    return (
        <>
            {courseTabMaster?.length > 0 &&
                <>
                    {courseTabMaster?.map((val, i) =>
                        <Accordion key={i}>
                            <AccordionSummary expandIcon={<MdExpandMore />} id={val?.tabname}>
                                <Box
                                    sx={{
                                        width: "100%",
                                        display: "flex",
                                        justifyContent: "space-between",
                                        pr: 3,
                                    }}
                                >
                                    <Typography>{val?.tabname}</Typography>
                                    <Box>
                                        <FormControlLabel
                                            control={
                                                <Radio
                                                    value="Yes"
                                                    sx={{ margin: 0, padding: 0 }}
                                                    checked={val?.isActive}
                                                    onChange={(e) => handleCourseTabChange(i, true, val?.coursetabid)}
                                                />
                                            }
                                            label="Yes"
                                        />
                                        <FormControlLabel
                                            control={
                                                <Radio
                                                    value="No"
                                                    sx={{ margin: 0, padding: 0 }}
                                                    checked={!val?.isActive}
                                                    onChange={(e) => handleCourseTabChange(i, false, val?.coursetabid)}
                                                />
                                            }
                                            label="No"
                                        />
                                    </Box>
                                </Box>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Grid container p={1}>
                                    <Grid item md={6} xs={12}>
                                    </Grid>
                                    <Grid
                                        item
                                        md={2}
                                        xs={12}
                                        sx={{ display: "flex", justifyContent: "center" }}
                                    >
                                        <Typography>Mandatory (Y/N)</Typography>
                                    </Grid>
                                    <Grid
                                        item
                                        md={2}
                                        xs={12}
                                        sx={{ display: "flex", justifyContent: "center" }}
                                    >
                                        <Typography>Existing data(Y/N)</Typography>
                                        {/* <Typography>Read only(Y/N)</Typography> */}
                                    </Grid>
                                    <Grid
                                        item
                                        md={2}
                                        xs={12}
                                        sx={{ display: "flex", justifyContent: "center" }}
                                    >
                                        <Typography>Additional Settings</Typography>
                                        {/* <Typography>Read only(Y/N)</Typography> */}
                                    </Grid>
                                </Grid>
                                <Grid container p={1}>
                                    <Grid item md={8} xs={12}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    disabled={!val?.isActive}
                                                    sx={{ margin: 0, padding: 0 }}
                                                    checked={val?.selectAll}
                                                    onChange={(e) => handleSelectAll(e, val?.coursetabid)}
                                                />
                                            }
                                            label={<span style={{ fontWeight: "bold" }}>Select All</span>}
                                        />
                                    </Grid>
                                    <Grid
                                        item
                                        md={8}
                                        xs={12}
                                        sx={{ display: "flex", justifyContent: "flex-end" }}
                                    >
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    disabled={!val?.isActive}
                                                    sx={{ margin: 0, padding: 0 }}
                                                    checked={val?.mandatorySelectAll}
                                                    onChange={(e) => handleMandatorySelectAll(e, val?.coursetabid)}
                                                />
                                            }
                                            label={<span style={{ fontWeight: "bold" }}>Select All</span>}
                                        />
                                    </Grid>
                                    <Grid
                                        item
                                        md={2}
                                        xs={12}
                                        sx={{ display: "flex", justifyContent: "center" }}
                                    >

                                    </Grid>
                                </Grid>
                                {courseFieldMaster?.filter((ff) => {
                                    if (val?.coursetabid === ff?.coursetabid) {
                                        return ff;
                                    }
                                })?.map((field, ind) =>
                                    <Grid container p={1} key={ind} mt={1}>
                                        <Grid item md={3} xs={12}>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        disabled={!val?.isActive}
                                                        checked={field.isSelected}
                                                        onChange={(e) => handleSelectField(e, field?.coursefieldid)}
                                                        sx={{ margin: 0, padding: 0 }}
                                                    />
                                                }
                                                label={field.fieldname}
                                                sx={{
                                                    alignItems: 'flex-start',
                                                }}
                                            />
                                        </Grid>
                                        <Grid item md={3} xs={12} sx={{ display: 'flex', flexDirection: 'column' }}>
                                            <TextField
                                                fullWidth
                                                type="text"
                                                value={field.fieldlabel}
                                                disabled={!val?.isActive || !field.isSelected}
                                                onChange={(e) => handleFieldLabelChange(e, field?.coursefieldid)}
                                                size="small"
                                            />
                                            {field?.fieldlabelerror &&
                                                <Typography variant="body2" sx={{ color: `${cssProperties?.color?.failure}` }}>required</Typography>
                                            }
                                        </Grid>

                                        <Grid
                                            item
                                            md={2}
                                            xs={12}
                                            sx={{
                                                display: "flex",
                                                justifyContent: "center",
                                            }}
                                        >
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        sx={{ margin: 0, padding: 0 }}
                                                        disabled={!val?.isActive || !field.isSelected}
                                                        checked={field?.ismandatory}
                                                        onChange={(e) => handleMandatoryChange(e, field?.coursefieldid)}
                                                    />
                                                }
                                            />
                                        </Grid>
                                        <Grid
                                            item
                                            md={2}
                                            xs={12}
                                            sx={{
                                                display: "flex",
                                                justifyContent: "center",
                                            }}
                                        >
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        sx={{ margin: 0, padding: 0 }}
                                                        disabled={!val?.isActive || !field.isSelected}
                                                        checked={field?.isreadonly}
                                                        onChange={(e) => handleReadonlyChange(e, field?.coursefieldid)}
                                                    />
                                                }
                                            />
                                        </Grid>
                                        {field?.isadditionalrequired ? (
                                            <Grid
                                                item
                                                md={2}
                                                xs={12}
                                                sx={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                }}
                                            >
                                                <Button disabled={!field?.isSelected} variant="outlined" size="small" style={{ width: "8rem", height: "3rem" }} onClick={(e) => handleOpenDocumentModal(field)}>
                                                    Additional Fields
                                                </Button>
                                            </Grid>
                                        ) : (
                                            <Grid
                                                item
                                                md={2}
                                                xs={12}
                                                sx={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                }}
                                            >
                                                <p>
                                                    ----
                                                </p>
                                            </Grid>
                                        )}
                                    </Grid>
                                )}
                            </AccordionDetails>
                        </Accordion>
                    )}
                    {/* <DocumentModal openDocModal={openDocModal} setOpenDocModal={setOpenDocModal} modalSpecificData={modalSpecificData} handleCheckBoxChange={handleCheckBoxChange} docChecked={docChecked} handleCustomTextChange={handleCustomTextChange} customText={customText} handleSubmitDocumentUrlFunc={handleSubmitDocumentUrlFunc}  /> */}

                    <Modal
                        open={openDocModal}
                        // onClose={handleClose}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                    >
                        <Box sx={style}>
                            <IconButton onClick={handleCloseModal} style={{ position: "absolute", right: 0, top: 5 }}>
                                <IoMdClose color="black" />
                            </IconButton>
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "end" }}>
                                <div>
                                    <Typography>Doc Link</Typography>
                                    <Checkbox
                                        checked={docChecked}
                                        onChange={handleCheckBoxChange}
                                        inputProps={{ 'aria-label': 'controlled' }}
                                    />
                                </div>

                                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                    <TextField disabled={!docChecked} value={customText || ""} id="outlined-basic" label="Custom Text" variant="outlined" size='small'
                                        onChange={(e) => handleCustomTextChange(e, matchingDocument)}
                                    />
                                    <TextField disabled={!docChecked} onChange={(e) => handleCustomLinkChange(e, matchingDocument)} value={customLinkField || ""} id="outlined-basic" label="Custom Link" variant="outlined" size='small' style={{ marginLeft: 10 }} />
                                </div>

                            </div>

                            <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                <Button disabled={!(docChecked && customText?.length > 0)} style={{ marginTop: "2rem" }} variant='outlined' size='small' onClick={() => {
                                    const matchedField = courseFieldMaster.find(e =>
                                        e.fieldname.toLowerCase().includes(matchingDocument.description.toLowerCase())
                                    )?.fieldname;

                                    if (matchedField) {
                                        handleSubmitDocumentUrlFunc(matchedField);
                                    }
                                }}>Submit</Button>
                            </div>
                        </Box>
                    </Modal>
                </>
            }
        </>
    )
};